<template>
  <div class="loading circle position">
    <div  class="rectangle">
      <svg x="0px" y="0px" viewBox="0 0 150 150" >
        <circle class="loading-inner" cx="75" cy="75" r="60"/>
      </svg>
      <p  class="desc" ><slot>Loading…</slot></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
  .loading {
    display: inline-block;
    z-index: 1000;
    &.noDescText:not(.position) svg {
      vertical-align: text-bottom;
      margin-right: 9px;
    }
    &.position {
      text-align: center;
      position: absolute;
      top: calc(50% - 5%);
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .rectangle {
      padding-top: 32px;
      margin: auto;
      width: 140px;
      height: 110px;
      top: 50%;
      border-radius: 14px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background-color: rgba(255, 255, 255, 0.8);
    }
    svg {
      animation: loading 3s linear infinite;
      width: 55px;
      height: 55px;

      .loading-inner {
        stroke: {
          dashoffset: 0;
          dasharray: 300;
          width: 20;
          miterlimit: 13;
          linecap: round;
        }

        animation: loading-circle 2s linear infinite;
        stroke: #ec0047;
        fill: transparent;
      }
    }
    p {
      margin-top: 12px;
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      color: #444444;
    }
    &.ie p {
      margin-top: -30px;
    }
    @keyframes loading {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes loading-circle {
      0% {
        stroke-dashoffset: 0
      }
      100% {
        stroke-dashoffset: -600;
      }
    }
  }
</style>
